import { render, staticRenderFns } from "./OutstandingOrders.vue?vue&type=template&id=59aedb2a&scoped=true&"
import script from "./OutstandingOrders.vue?vue&type=script&lang=js&"
export * from "./OutstandingOrders.vue?vue&type=script&lang=js&"
import style0 from "./OutstandingOrders.vue?vue&type=style&index=0&id=59aedb2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aedb2a",
  null
  
)

export default component.exports